/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateAccountInfoDto } from '../../models/update-account-info-dto';
import { UpdateAccountInfoResponse } from '../../models/update-account-info-response';

export interface UpdateSessionAccountInfo$Params {
      body: UpdateAccountInfoDto
}

export function updateSessionAccountInfo(http: HttpClient, rootUrl: string, params: UpdateSessionAccountInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateAccountInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, updateSessionAccountInfo.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateAccountInfoResponse>;
    })
  );
}

updateSessionAccountInfo.PATH = '/api/v2/session/account-info';
